"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStrongs = getStrongs;
exports.getCurrency = getCurrency;
exports.isEmpty = isEmpty;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function getStrongs(value) {
  var splittedValue = value.split('__s');

  if (splittedValue.length % 2 === 0) {
    console.error("There might be a __s missing in your translation : ".concat(value));
  }

  return splittedValue.map(function (part, index) {
    var element = index % 2 === 0 ? 'span' : 'strong';
    return /*#__PURE__*/_react.default.createElement(element, {
      key: index
    }, part);
  });
}

function getCurrency(value, unit) {
  var splittedValue = value.split('__c');

  if (splittedValue.length % 2 === 0) {
    console.error("There might be a __c missing in your translation : ".concat(value));
  }

  return splittedValue.map(function (part, index) {
    if (index % 2 === 0) {
      return part;
    }

    var formattedNumber = Number(part / 100).toFixed(2);

    if (formattedNumber.endsWith('.00')) {
      formattedNumber = formattedNumber.substring(0, formattedNumber.length - 3);
    }

    return formattedNumber + unit;
  }).join('');
}

function isEmpty(value) {
  if (value === undefined || value === null) {
    return true;
  }

  if (typeof value === 'string' || value instanceof String) {
    return value.trim() === '';
  }

  return false;
}

var stringUtils = {
  getStrongs: getStrongs,
  getCurrency: getCurrency,
  isEmpty: isEmpty
};
var _default = stringUtils;
exports.default = _default;
//# sourceMappingURL=strings.js.map